import React from 'react';
import {Button } from 'antd';
import { FaFileCsv } from '@react-icons/all-files/fa/FaFileCsv';

const SettlementPaymentFileDownloadButton = ({onClick}: {onClick:()=>void}) => {
	return(
		<Button 
			type="primary"
			icon={ <FaFileCsv /> }
			onClick={onClick}
			size={'middle'}
		/>
	)
}

export default SettlementPaymentFileDownloadButton ;
